import { Helper } from '../Helper';
export class MapFilterHelper extends Helper {
    constructor(options) {
        super();
        this.map = options.map;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.emitOp(node, 'NEWMAP');
        sb.emitHelper(node, options, sb.helpers.rawIteratorReduce({
            each: (innerOptions) => {
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'ROT');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'SWAP');
                sb.emitHelper(node, innerOptions, sb.helpers.if({
                    condition: () => {
                        this.map(innerOptions);
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'ROT');
                        sb.emitPushInt(node, 3);
                        sb.emitOp(node, 'XTUCK');
                        sb.emitOp(node, 'ROT');
                        sb.emitOp(node, 'ROT');
                        sb.emitOp(node, 'SETITEM');
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DROP');
                        sb.emitOp(node, 'DROP');
                    },
                }));
            },
        }));
    }
}

//# sourceMappingURL=MapFilterHelper.js.map
